import { Popup } from 'devextreme-react';
import { TemporalRemissions } from '../Components/TemporalRemissions';
import '../referrals.scss';

interface ModalTemporalRemissionsProps {
  visible: boolean;
  onClose: (refresh?: boolean) => void;
}

export const ModalTemporalRemissions = ({ visible, onClose }: ModalTemporalRemissionsProps) => {
  const handleClose = () => {
    onClose(true); // Siempre refrescar al cerrar
  };

  return (
    <Popup
      visible={visible}
      onHiding={handleClose}
      dragEnabled={true}
      hideOnOutsideClick={false}
      showCloseButton={true}
      showTitle={true}
      title='Remisiones Temporales'
      width='90%'
      height='80%'
      wrapperAttr={{ class: 'temporal-remissions-modal' }}>
      <div className='modal-content'>
        <TemporalRemissions onClose={handleClose} />
      </div>
    </Popup>
  );
};
